/* eslint-disable */
import { defineStore } from 'pinia';
import _ from 'lodash';

export const useFooterSectionStore = defineStore('footer_section', {
	state: () => ({
		footer_section: [],
	}),
	getters: {
		getFooterSections(state) {
			return state.footer_section;
		},
		getSocialSection(state) {
			return _.find(state.footer_section, { name: 'Social' }) || null;
		},
		getRegulationSection(state) {
			return _.find(state.footer_section, { name: 'Regulation' }) || null;
		},
		getDescriptionSection(state) {
			return _.find(state.footer_section, { name: 'Description' }) || null;
		},
		getContactSection(state) {
			return _.find(state.footer_section, { name: 'Contact' }) || null;
		},
		getPaymentSection(state) {
			return _.find(state.footer_section, { name: 'Payments' }) || null;
		},
		getLanguageSelectorSection(state) {
			return _.find(state.footer_section, { name: 'Language Selector' }) || null;
		},
		getLivechatSection(state) {
			return _.find(state.footer_section, { name: 'Livechat' }) || null;
		},
		hasEmrSealInRegulation(state) {
			const regulation = _.find(state.footer_section, { name: 'Regulation' });
			return _.some(regulation?.items, item => item.type === 'emr_seal' && item.enabled !== false);
		},
		getEmrSealItem(state) {
			const regulation = _.find(state.footer_section, { name: 'Regulation' });
			return _.find(regulation?.items, item => item.type === 'emr_seal' && item.enabled !== false) || null;
		},
		hasAnjSealInRegulation(state) {
			const regulation = _.find(state.footer_section, { name: 'Regulation' });
			return _.some(regulation?.items, { type: 'anj_seal' });
		},
		getAnjSealItem(state) {
			const regulation = _.find(state.footer_section, { name: 'Regulation' });
			return _.find(regulation?.items, { type: 'anj_seal' }) || null;
		},
		getLanguageFlag: (state) => (locale) => {
			let flags = {
				en: '/assets/images/country-flags/flat/england.png',
				de: '/assets/images/country-flags/flat/germany.png',
				fr: '/assets/images/country-flags/flat/france.png',
				es: '/assets/images/country-flags/flat/spain.png',
				fa: '/assets/images/country-flags/flat/iran.png',
				gr: '/assets/images/country-flags/flat/greece.png',
				pt: '/assets/images/country-flags/flat/portugal.png',
				sr: '/assets/images/country-flags/flat/serbia.png',
				tr: '/assets/images/country-flags/flat/turkey.png',
				it: '/assets/images/country-flags/flat/italy.png',
				ru: '/assets/images/country-flags/flat/russia.png',
				ar: '/assets/images/country-flags/flat/united_arab_emirates.png'
			}
			return flags[locale];
		}
	},
	actions: {
		fetchFooterSections() {
			return global.axios.get(process.env.VUE_APP_API_URL + '/footer-sections').then((response) => {
				this.footer_section.splice(0, this.footer_section.length, ...response.data);
				return Promise.resolve(response.data);
			}).catch((error) => {
				this.footer_section = 'not_found';
				return Promise.reject();
			});
		}
	},
})